import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, hasClass, findIn, trigger, findAllIn, closest, on} from '@elements/dom-utils';
import * as datepicker from "@elements/datepicker";

export function init () {
    onFind('.js-datepicker-radio', baseElement => {
        let lineRadios = findAllIn('.js-datepicker-radio__check-input', baseElement);
        let datePicker = findIn('.js-datepicker', baseElement);
        let datePickerInput = findIn('.js-datepicker__input', baseElement);
        let submitButton = findIn('.js-datepicker-radio__submit', baseElement);

        Promise.all([datepicker.getApi(datePicker)]).then(function([datepickerApi]) {
            let instance = datepickerApi.getDatepickerInstance();

            lineRadios.map(lineRadio => {
                on('change', (e) => {
                    if(datepickerApi.getDate()){
                        instance.clear();
                    }
                    lineRadio.checked = true;
                    //needed to trigger submit section
                    trigger('click', submitButton);
                }, lineRadio);
            });

            on('change', (e) => {
                if(e.target.value !== ''){
                    lineRadios.map(lineRadio => {
                        if(lineRadio.checked) {
                            lineRadio.checked = !lineRadio.checked;
                        }
                    });
                    //needed to trigger submit section
                    trigger('click', submitButton);
                }
            }, datePickerInput );
        });
    });
}